import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_graduationcap: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-graduationcap" {...rest}>
      <title>praise-graduationcap</title>
      <ellipse
        transform="rotate(-88.267 74.997 75.003) scale(.99996)"
        fill="#FB7F78"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
        opacity=".8"
      ></ellipse>
      <path fill="#386CBB" d="M111.7 94.3c0 11.8-16.3 21.4-36.3 21.4S39 106.1 39 94.3V72.8l72.6-1.8.1 23.3z"></path>
      <path fill="#6C98D9" d="M75.3 37L18 69.1l57.3 32.1 57.4-32.1z"></path>
      <path
        fill="#F9A0A0"
        d="M75.3 37l57.3 32.1-57.3 32.1L18 69.1 75.3 37m0-2.9l-1.2.7-57.3 32.1-3.8 2.2 3.8 2.2 57.3 32.1 1.2.7 1.2-.7 57.3-32.1 3.8-2.2-3.8-2.2-57.3-32.1-1.2-.7z"
      ></path>
      <path
        fill="#19345D"
        d="M124.2 116.8c-.5 0-1-.3-1.3-.8-.2-.3-4.7-8.3-4.2-14.9.1-.7.1-1.5.2-2.5.6-6 2-20.2-3.2-22-7-2.4-39.5-8.9-39.8-8.9-.8-.2-1.3-.9-1.2-1.8.2-.8.9-1.3 1.8-1.2 1.3.3 33 6.5 40.2 9.1 7.5 2.6 6.1 16.7 5.2 25.1-.1.9-.2 1.7-.2 2.4-.5 5.6 3.8 13.1 3.8 13.1.4.7.2 1.6-.6 2-.2.3-.5.4-.7.4z"
      ></path>
      <ellipse fill="#19345D" cx="77.2" cy="66.3" rx="4" ry="3"></ellipse>
    </svg>
  );
};
